import { useMemo, useState } from 'react';
import { ApolloError } from '@apollo/client';

import {
  useGetMemberAttachmentUrlsQuery,
  useGetAlsMemberActivitiesInProgressByKeyQuery,
  GetAlsMemberActivitiesInProgressByKeyQuery
} from 'src/graphql/generated';
import { useErrorHandler } from 'src/hooks/useErrorHandler';

export const useMemberActivity = ({
  activityKey,
  memberId,
  skip
}: {
  memberId: string | undefined | null;
  activityKey?: string;
  skip: boolean;
}) => {
  const handleError = useErrorHandler();
  const [data, setData] = useState<GetAlsMemberActivitiesInProgressByKeyQuery | undefined>();
  const [error, setError] = useState<ApolloError | undefined>();

  const { data: formData, loading } = useGetAlsMemberActivitiesInProgressByKeyQuery({
    variables: { memberId: memberId, activityKey: activityKey },
    skip: !skip,
    onCompleted: setData,
    onError: (error) => {
      setError(error);
      if (!error?.message?.includes('Activity')) {
        handleError(error);
      }
    },
    fetchPolicy: 'cache-and-network'
  });

  const existingAttachments = data?.getALSMemberActivitiesInProgressByKey?.attachments?.map(
    (attachment) => {
      const { url, __typename, ...rest } = attachment!;
      return {
        ...rest
      };
    }
  );

  const { data: memberAttachmentsUrls } = useGetMemberAttachmentUrlsQuery({
    variables: { memberid: memberId, attachments: existingAttachments },
    skip: !data && !existingAttachments
  });

  const memberActivityData: GetAlsMemberActivitiesInProgressByKeyQuery | undefined = useMemo(() => {
    return memberAttachmentsUrls && formData?.getALSMemberActivitiesInProgressByKey
      ? {
          getALSMemberActivitiesInProgressByKey: {
            ...formData.getALSMemberActivitiesInProgressByKey,
            attachments: memberAttachmentsUrls?.getMemberAttachmentsUrls
          }
        }
      : undefined;
  }, [data?.getALSMemberActivitiesInProgressByKey, memberAttachmentsUrls]);

  return { memberActivityData, error, loading };
};
